import {SET_ACTIVE_BET_LIST} from "@actions/actionTypes";

export default function activeBetsListReducer(state = [], action) {
    switch (action.type) {
        case SET_ACTIVE_BET_LIST:
            return action.bets
        default:
            return state;
    }
}
